import * as m from "./model";

// Room mode only ever forces how the deal is framed (recap vs straight acquisition).
export const applyRoomMode = (M, mode) => (mode === "recap" ? { ...M, txnType: "recap" } : mode === "standalone" ? { ...M, txnType: "acquisition" } : M);

// The deal view selected in the app (saved on the model) always wins, so the room mirrors every
// screen. Legacy rooms fall back to their published scope, then to the platform view.
export const roomScope = (snapshot, M) => {
  const opts = m.scopeOptions(M) || [];
  const explicit = (M && M.viewScope) || "";
  const legacy = (snapshot || {}).scope || "";
  // Rooms published before the DEAL selector existed captured "platform" by default. A recapitalisation
  // that owns add-ons is a consolidated story, so don't strand it on the standalone view.
  if (!explicit && (!legacy || legacy === m.SCOPE_PLATFORM)) return m.defaultScope(M);
  const s = explicit || legacy;
  if (!s) return m.SCOPE_PLATFORM;
  return opts.some((o) => o.id === s) ? s : m.SCOPE_PLATFORM;
};

// Single source of truth for "what the investor sees": used by the room itself and by the
// admin-side reconciliation card, so a mismatch can never come from two different derivations.
export function roomModel(share, liveM) {
  const snapshot = (share && share.snapshot) || {};
  const Mraw = m.coerceModel(liveM || snapshot.M || {});
  const scope = roomScope(snapshot, Mraw);
  const M0 = m.scopedModel(Mraw, scope);
  const ask = Number((share || {}).equityAsk) || 0;
  const mode = (share || {}).roomMode || "auto";
  return {
    M: applyRoomMode(ask > 0 ? { ...M0, lpEquity: ask } : M0, mode),
    scope, mode, askOverride: ask > 0 ? ask : 0,
    scopeShort: m.scopeLabel(Mraw, scope) || "This deal only",
    scopeLong: ((m.scopeOptions(Mraw) || []).find((o) => o.id === scope) || {}).label || "This deal only — platform view",
  };
}

// Headline outputs of any model view, for side-by-side reconciliation.
export function viewOutputs(V) {
  const ex = m.exitReturns(V), wf = m.lpWaterfall(V);
  return { ask: ex.lpAsk, entry: m.entryMultiple(V), exit: V.exitMult || 0, hold: m.effectiveHold(V),
    irr: ex.irr, moic: ex.moic, lpIrr: wf.lpIrr, lpMoic: wf.lpMoic, dscr: m.dscrYr1(V), fcf1: m.model5yr(V)[0].fcf };
}
